module.exports = __webpack_public_path__ + "img/dashimg01.d5408b30.png";